module.exports = __webpack_public_path__ + "img/num04.5fdca7ee.svg";